import script from "./RelatedGamesSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelatedGamesSelector.vue?vue&type=script&setup=true&lang=ts"

import "./RelatedGamesSelector.vue?vue&type=style&index=0&id=c9e74a90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9e74a90"]])

export default __exports__